import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledAside = styled.aside`
  flex: 0 0 25%;
  padding: 2px;
  margin: 20px;
  background-color: #cdffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  @media (max-width: 767px) {
    // padding: 10px;
    margin: 20px 0;
  }
`;

const StyledLink = styled(Link)`
  display: block;
//   width: 100%;
  padding: 10px;
  margin-bottom: 2px;
  background-color: #f5f5f5;
  // background-color: #f5f5f5;
  color: #333;
  text-align: center;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;

  &:hover {
    background-color: #333;
    color: #fff;
  }
`;


function Aside(props) {
  const links = props.links.map((link, index) => (
    <li className="link-item" key={index}>
      <StyledLink to={link.url}>{link.text}</StyledLink>
    </li>
  ));

  return (
    <StyledAside>
      <ul>{links}</ul>
    </StyledAside>
  );
}

export default Aside;
